import { forwardRef, HTMLProps } from 'react'
import clsx from 'classnames'
import style from './document.module.scss'

export interface DocumentProps extends HTMLProps<HTMLAnchorElement> {}

export const Document = forwardRef<HTMLAnchorElement, DocumentProps>((props, ref) => {
  const { className, children, href, ...restProps } = props

  return (
    <a className={clsx(style.document, className)} ref={ref} href={href ?? ''} download target="_blank">
      {children}
    </a>
  )
})

Document.displayName = 'Document'
